import React from 'react';
import Hightcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const ChartColumn = ({chartData, title}) => {
  if (chartData == undefined || chartData.length == 0) {
      return
  }

  //Column, line and pie
  const optionsBar = {
    title: {
      text: title,
      style : {
        color : '#000',
        fontSize : "14px",
        fontWeight : "bold"
      }
    },
    colors: ["#66c2a5", "#fc8d62", "#8da0cb", "#e78ac3", "#a6d854"],
    xAxis: {
      categories: chartData[0]
    },
    yAxis: {
      min: 0,
      title: {
        text: '인구수(명)'
      },
    },
    tooltip: {
      pointFormat: '{point.y} 명'
    },
    series: [{
      data: chartData[1],
    }],
    legend: {
      enabled: false // 항목 이름 제거
    },
  };

  return (
    <>
      <HighchartsReact highcharts = {Hightcharts} options = {optionsBar}  containerProps={{ style: { width:'100%' ,height: "90%" } }}
      />
    </>
  );
};

export default ChartColumn;